module.exports = __webpack_public_path__ + "img/新版-我们-愿景_02.50092915.jpg";